import React, { Component, createRef } from "react";
import Layout from "./../layouts/Index";
import { withRouter, Link } from "react-router-dom";
import queryString from "query-string";
import { connect } from "react-redux";
import BlockLoader from "./../contentloaders/BlockLoader";
import {
  Row,
  Col,
  Container,
  Table,
  Modal,
  Form,
  Button,
  FormControl,
  Alert,
  InputGroup,
} from "react-bootstrap";
import {
  getOrders,
  editOrder,
  getMoreOrders,
  searchOrder,
} from "./../../store/actions/OrderActions";
import { getMoqs } from "./../../store/actions/MoqActions";
import { getSuppliers } from "./../../store/actions/SupplierActions";
import { createSchema, updateOrderStatusSchema } from "./../../helpers/validation/order";
import { toast } from "react-toastify";
import { Formik } from "formik";
import Select from "react-select/async";
import moment from "moment";
import { instance, setAuthToken } from '../../helpers/instance';
import { FaSearch } from "react-icons/fa";

class Index extends Component {
  constructor(props) {
    super(props);

    this.selectRef = createRef(null);

    this.state = {
      showModal: false,

      order: {},

      loading: false,

      search: "",

      checked: false,

      charLimit: 300,

      showUpdatedOrderStatusModal: false,
    };
  }

  componentDidMount = async () => {
    this.setState({ loading: true });

    const { location } = this.props;

    if (location.search !== "") {
      const values = queryString.parse(location.search);

      if (values.order_modal !== undefined && values.order_modal === "true") {
        this.setState({ showModal: true });
      }
    }

    await this.props.getMoqs();

    await this.props.getSuppliers();

    const res = await this.props.getOrders();

    if (res) {
      this.setState({ loading: false });
    }
  };

  toggleModal = (order) => {
    if (order !== undefined) {
      this.setState({ order });
    }

    this.setState({ showModal: !this.state.showModal });
  };

  toggleUpdateOrderStatusModal = () => {
    this.setState({ showUpdatedOrderStatusModal: !this.state.showUpdatedOrderStatusModal });
  };

  editOrder = async (values) => {
    try {
      if (
        values.status === "Goods arrived at Litudian - Ready to collect" &&
        values.shipping_fee === ""
      ) {
        return toast.error("Shipping Fee Is Required !", {
          position: "bottom-center",
        });
      }

      const { order, checked } = this.state;

      if (checked === true) {
        values.send_sms = 1;
      } else {
        delete values.send_sms;
      }

      this.setState({ loading: true });

      const result = await this.props.editOrder(order.id, values);

      if (result) {
        toast.success("Order Details Edited Successfully !", {
          position: "bottom-center",
        });

        this.setState({ showModal: false, checked: false, loading: false });

        await this.props.getOrders();
      }
    } catch (error) {
      console.log(error);

      this.setState({ checked: false, loading: false });
    }
  };

  fetchMoreOrders = async () => {
    try {
      this.setState({ loading: true });

      const {
        orders: { next_page },
      } = this.props;

      const result = await this.props.getMoreOrders(next_page);

      if (result) {
        this.setState({ loading: false });
      }
    } catch (error) {
      console.log(error);
    }
  };

  searchOrder = async () => {
    try {
      let obj = { order_number: this.state.search };

      this.setState({ loading: true });

      const result = await this.props.searchOrder(obj);

      if (result) {
        this.setState({ loading: false });
        if (result.length === 0) {
          return toast.warning("Order Not Found!", {
            position: "bottom-center",
          });
        }

        toast.success("Order Found!", {
          position: "bottom-center",
        });

        return this.props.history.push(`/admin/orders/${result[0].id}`);
      }
    } catch (error) {
      this.setState({ loading: false });

      if (error.response !== undefined && error.response.status === 404) {
        toast.warning("Order Not Found!", {
          position: "bottom-center",
        });
      }
    }
  };


  loadOptions = async (inputValue) => {
    try {
      setAuthToken(instance);
      const response = await instance.post(`search/orders`, { order_number: inputValue });
      return response.data.map(order => ({
        value: order.id,
        orderNumber: order.number,
        moqNumber: order.moq_number,
        orderStatus: order.status,
        orderETA: order.eta,
      }));
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  keyPress = async (e) => {
    try {
      if (e.keyCode === 13) {
        await this.searchOrder();
      }
    } catch (error) {
      console.log(error);
    }
  };

  handleChange = (e) => {
    this.setState({ search: e.target.value });
  };

  refresh = async () => {
    this.setState({ loading: true });

    const result = await this.props.getOrders();

    if (result) {
      this.setState({ loading: false, search: ""});
    }
  };

  render() {
    const {
      orders,
      suppliers,
      orders: { page, pages },
    } = this.props;

    const { order, loading, charLimit } = this.state;

    // console.log(order);

    return (
      <Layout>
        <Col sm="12" style={{ minHeight: "170vh", padding: "1.5em 0" }}>
          <Container>
            <Row>
              <Col xs="12" md="6" lg="4" className="mb-3 mx-auto">
                <Form
                  onSubmit={async (e) => {
                    e.preventDefault();
                    if (!this.state.search || !this.state.search.trim()) return; // avoid undefined
                    await this.searchOrder();
                  }}
                >
                  <InputGroup className="search-input-group">
                    <FormControl
                      type="text"
                      name="search"
                      id="search"
                      placeholder="Search PO/MOQ NUmber"
                      value={this.state.search || ""} // safe fallback
                      onChange={this.handleChange}
                      ref={(input) => (this.searchInput = input)}
                      className="rounded-pill shadow-sm"
                    />
                    {this.state.search && (
                      <Button
                        variant="outline-secondary"
                        onClick={() => {
                          this.setState({ search: "" }, () => {
                            this.refresh();
                          });
                        }}
                        className="rounded-circle shadow-sm d-flex align-items-center justify-content-center ms-2"
                        style={{
                          width: "40px",
                          height: "40px",
                          padding: 0,
                        }}
                      >
                        ×
                      </Button>
                    )}
                    <Button
                      variant="success"
                      type="submit"
                      disabled={!this.state.search || !this.state.search.trim()}
                      className="rounded-circle shadow-sm d-flex align-items-center justify-content-center ms-2"
                      style={{
                        width: "40px",
                        height: "40px",
                        padding: 0,
                      }}
                    >
                      <FaSearch size={16} />
                    </Button>
                  </InputGroup>
                </Form>
              </Col>

                      <Col
                      sm="12"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexDirection: "row",
                        marginBottom: "1em",
                      }}
                      >
                      {!loading && <h3>Orders</h3>}

                      {loading && (
                        <div style={{ width: "100px", height: "35px" }}>
                        <BlockLoader
                          width="150px"
                          height="35"
                          innerHeight="100%"
                          innerWidth="100%"
                          style={{ margin: "0", padding: "0" }}
                        />
                        </div>
                      )}

                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => this.toggleUpdateOrderStatusModal()}
                        disabled={loading}
                      >
                        Bulk Edit PO Statuses
                      </Button>
                      </Col>

                      <Col sm="12">
                      {!loading && (
                        <div className="table">
                        <Table
                          striped
                          bordered
                          hover
                          size="lg"
                          variant="light"
                          responsive="sm"
                          className="orders-table"
                        >
                          <thead>
                          <tr>
                            <th>#</th>
                            <th>Order No.</th>
                            <th>Product Name</th>
                            <th>MOQ No.</th>
                            <th>Date Created</th>
                            <th>Supplier</th>
                            <th>Status</th>
                          </tr>
                          </thead>
                          <tbody>
                          {orders.data.map((order, i) => (
                            <tr key={i}>
                            <td data-label="#"> {i + 1}</td>
                            <td data-label="PO Number">
                              <Link to={`/admin/orders/${order.id}`}>{order.order_number}</Link>
                            </td>
                            <td data-label="Product Name">
                              <Link 
                                to={`/admin/products/${order.product[0].id}`} 
                                style={{ display: "flex", alignItems: "center", gap: "0.5rem", textDecoration: "none" }}
                              >
                                <span style={{ color: "#0d6efd" }}>{order.product[0].name}</span>
                              </Link>
                            </td>
                            <td data-label="Campaign Number">
                              <Link to={`/admin/moqs/${order.moq[0].id}`}>
                              {order.moq[0].moq_number}
                              </Link>
                            </td>
                            <td data-label="Date Created">
                              {new Date(order.date_created).toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "short",
                                day: "numeric"
                              })
                            }
                            </td>
                            <td data-label="Supplier">{order.supplier[0].name}</td>
                            <td data-label="Status">
                              {order.status &&
                              order?.status === "Order Deleted" ? (
                              <span style={{ color: "red" }}>
                                {order?.status}
                              </span>
                              ) : (
                              order?.status
                              )}
                            </td>
                            </tr>
                          ))}
                          </tbody>
                        </Table>
                        </div>
                      )}
                      </Col>

                      <Col sm="12">
                      {loading && (
                        <BlockLoader
                        width="100%"
                        height="400px"
                        innerWidth="100%"
                        innerHeight="100%"
                        />
                      )}
                      </Col>

                      {page < pages && (
                      <Col
                        sm="12"
                        style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: "2em",
                        }}
                      >
                        <Button
                        variant="primary"
                        size="lg"
                        onClick={() => this.fetchMoreOrders()}
                        disabled={loading}
                        >
                        {loading === true ? "Loading ..." : "Load More"}
                        </Button>
                      </Col>
                      )}
                    </Row>
                    </Container>
                  </Col>

                  {/* Add responsive table styles */}
                  <style>
                    {`
                    @media (max-width: 767px) {
                      .table-responsive {
                      overflow-x: auto;
                      }
                      .orders-table thead {
                      display: none;
                      }
                      .orders-table tbody tr {
                      display: block;
                      margin-bottom: 1em;
                      border: 1px solid #dee2e6;
                      border-radius: 8px;
                      box-shadow: 0 1px 2px rgba(0,0,0,0.03);
                      }
                      .orders-table tbody td {
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      padding: 0.75em 1em;
                      border: none;
                      border-bottom: 1px solid #f1f1f1;
                      font-size: 0.95em;
                      }
                      .orders-table tbody td:last-child {
                      border-bottom: none;
                      }
                      .orders-table tbody td:before {
                      content: attr(data-label);
                      font-weight: bold;
                      flex-basis: 50%;
                      text-align: left;
                      color: #555;
                      padding-right: 1em;
                      }
                    }
                    `}
                  </style>}
        <Modal show={this.state.showModal} onHide={this.toggleModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Edit Order</Modal.Title>
          </Modal.Header>

          <Formik
            enableReinitialize={true}
            initialValues={{
              moq_id: order.moq_id !== undefined ? order.moq_id : 0,
              supplier_id:
                order.supplier_id !== undefined ? order.supplier_id : "",
              status: order.status !== undefined ? order.status : "",
              shipping_fee:
                order.shipping_fee !== undefined ? order.shipping_fee : "",
              total_cost: order.total_cost !== undefined ? order.total_cost : 0,
              shipping_company:
                order.shipping_company !== undefined
                  ? order.shipping_company
                  : "",
              order_remarks:
                order.order_remarks !== undefined ? order.order_remarks : "",
            }}
            validationSchema={createSchema}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
              this.editOrder(values);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <div>
                <Modal.Body>
                  <Form.Group as={Row} controlId="moq_id">
                    <Form.Label column sm="3">
                      Moq
                    </Form.Label>

                    <Col sm="9">
                      <Form.Control
                        as="select"
                        isValid={touched.moq_id && !errors.moq_id}
                        isInvalid={errors.moq_id && touched.moq_id}
                        name="moq_id"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        defaultValue={values.moq_id}
                        disabled
                      >
                        {/* <option value={0}>Choose ...</option> */}

                        {order.moq_id !== undefined && (
                          <option value={order.moq[0].id}>
                            {order.moq[0].moq_number}
                          </option>
                        )}

                        {/* {moqs.data.map((moq, i) => <option key={i} value={moq.id} selected={values.moq_id === moq.id}>{moq.moq_number}</option>)} */}
                      </Form.Control>

                      {errors.moq_id && touched.moq_id && (
                        <Form.Control.Feedback type="invalid">
                          {errors.moq_id}
                        </Form.Control.Feedback>
                      )}
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="supplier">
                    <Form.Label column sm="3">
                      Supplier
                    </Form.Label>

                    <Col sm="9">
                      <Form.Control
                        as="select"
                        isValid={touched.supplier_id && !errors.supplier_id}
                        isInvalid={errors.supplier_id && touched.supplier_id}
                        name="supplier_id"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        defaultValue={values.supplier_id}
                        disabled
                      >
                        <option value="">Choose ...</option>

                        {suppliers.map((supplier, i) => (
                          <option key={i} value={supplier.id}>
                            {supplier.name}
                          </option>
                        ))}
                      </Form.Control>

                      {errors.supplier_id && touched.supplier_id && (
                        <Form.Control.Feedback type="invalid">
                          {errors.supplier_id}
                        </Form.Control.Feedback>
                      )}
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="shipping_fee">
                    <Form.Label column sm="3">
                      Shipping Fee
                    </Form.Label>

                    <Col sm="9">
                      <Form.Control
                        type="number"
                        placeholder="Shipping Fee"
                        name="shipping_fee"
                        isValid={touched.shipping_fee && !errors.shipping_fee}
                        isInvalid={errors.shipping_fee && touched.shipping_fee}
                        value={values.shipping_fee}
                        onChange={handleChange}
                        disabled={
                          values.status !==
                          "Goods arrived at Litudian - Ready to collect"
                        }
                      />

                      {errors.shipping_fee && touched.shipping_fee && (
                        <Form.Control.Feedback type="invalid">
                          {errors.shipping_fee}
                        </Form.Control.Feedback>
                      )}
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="total_cost">
                    <Form.Label column sm="3">
                      Total Shipping Cost
                    </Form.Label>

                    <Col sm="9">
                      <Form.Control
                        type="number"
                        placeholder="Total Shipping Cost"
                        name="total_cost"
                        isValid={touched.total_cost && !errors.total_cost}
                        isInvalid={errors.total_cost && touched.total_cost}
                        value={values.total_cost}
                        onChange={handleChange}
                        disabled={
                          values.status !==
                          "Supplier acknowledged - Preparing goods"
                        }
                      />

                      {errors.total_cost && touched.total_cost && (
                        <Form.Control.Feedback type="invalid">
                          {errors.total_cost}
                        </Form.Control.Feedback>
                      )}
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="shipping_company">
                    <Form.Label column sm="3">
                      Shipping Company
                    </Form.Label>

                    <Col sm="9">
                      <Form.Control
                        type="text"
                        placeholder="Shipping Company"
                        name="shipping_company"
                        isValid={
                          touched.shipping_company && !errors.shipping_company
                        }
                        isInvalid={
                          errors.shipping_company && touched.shipping_company
                        }
                        value={values.shipping_company}
                        onChange={handleChange}
                      />

                      {errors.shipping_company && touched.shipping_company && (
                        <Form.Control.Feedback type="invalid">
                          {errors.shipping_company}
                        </Form.Control.Feedback>
                      )}
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="status">
                    <Form.Label column sm="3">
                      Status
                    </Form.Label>

                    <Col sm="9">
                      <Form.Control
                        as="select"
                        isValid={touched.status && !errors.status}
                        defaultValue={values.status}
                        isInvalid={errors.status && touched.status}
                        name="status"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <option value="">Choose...</option>

                        <option value="Submitted - Pending supplier acknowledgement">
                          Submitted - Pending supplier acknowledgement
                        </option>

                        <option value="Supplier acknowledged - Preparing goods">
                          Supplier acknowledged - Preparing goods
                        </option>

                        <option value="At shipper - Loading goods">
                          At shipper - Loading goods
                        </option>

                        <option value="Shipper loaded - Goods in transit">
                          Shipper loaded - Goods in transit
                        </option>

                        <option value="Arrived - Customs clearance">
                          Arrived - Customs clearance
                        </option>

                        <option value="Arrived - At shipper warehouse">
                          Arrived - At shipper warehouse
                        </option>

                        <option value="Goods arrived at Litudian - Ready to collect">
                          Goods arrived at Litudian - Ready to collect
                        </option>

                        <option value="Order cancelled">Order cancelled</option>
                      </Form.Control>

                      {errors.status && touched.status && (
                        <Form.Control.Feedback type="invalid">
                          {errors.status}
                        </Form.Control.Feedback>
                      )}
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="order_remarks">
                    <Form.Label column sm="3">
                      Remarks
                    </Form.Label>

                    <Col sm="9">
                      <FormControl
                        as="textarea"
                        aria-label="With textarea"
                        name="order_remarks"
                        placeholder="write ..."
                        isValid={touched.order_remarks && !errors.order_remarks}
                        isInvalid={
                          errors.order_remarks && touched.order_remarks
                        }
                        value={values.order_remarks}
                        onChange={(e) => {
                          let txt = e.target.value;

                          if (txt.length <= charLimit) {
                            setFieldValue("order_remarks", txt);
                          }
                        }}
                      />

                      {errors.order_remarks && touched.order_remarks && (
                        <Form.Control.Feedback type="invalid">
                          {errors.order_remarks}
                        </Form.Control.Feedback>
                      )}

                      <span style={{ paddingTop: "5px", fontSize: "12px" }}>
                        {charLimit - values.order_remarks.length} characters
                        remaining.
                      </span>
                    </Col>
                  </Form.Group>

                  {values.status === "arrived" && (
                    <Form.Group controlId="formBasicCheckbox">
                      <Form.Check
                        checked={this.state.checked}
                        onChange={(e) => {
                          this.setState({ checked: e.target.checked });
                        }}
                        type="checkbox"
                        label="Send SMS"
                      />
                    </Form.Group>
                  )}

                  {this.state.checked === true && (
                    <Col sm="12">
                      <Alert variant="warning">
                        Clicking submit will send an SMS with shipping fee as{" "}
                        {values.shipping_fee}. Continue ?
                      </Alert>
                    </Col>
                  )}
                </Modal.Body>

                <Modal.Footer>
                  <Button variant="secondary" onClick={this.toggleModal}>
                    Close
                  </Button>

                  <Button
                    variant="primary"
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    Edit Order
                  </Button>
                </Modal.Footer>
              </div>
            )}
          </Formik>
        </Modal>

        {/* Update Order Status Modal */}
        <Modal
          show={this.state.showUpdatedOrderStatusModal}
          onHide={this.toggleUpdateOrderStatusModal}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Bulk Edit PO Statuses</Modal.Title>
          </Modal.Header>

          <Formik
            enableReinitialize
            initialValues={{
              order_id_list: [],
              status: "",
              eta: "",
            }}
            validationSchema={updateOrderStatusSchema}
            validateOnBlur={true}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
              try {
                setSubmitting(true)
                if (values.eta !== "") {
                  values.eta = moment(values.eta).format("YYYY-MM-DD HH:mm:ss");
                }
                setAuthToken(instance);
                const response = await instance.patch("order-status", values);
                setSubmitting(false)
                if (response.data?.message) {
                  toast.success(`${response.data?.message}`, {
                    position: "bottom-center",
                  });
                } else {
                  toast.success(`Bulk PO Statuses Updated Successfully !`, {
                    position: "bottom-center",
                  });
                }
                resetForm()
                if (this.selectRef.current) {
                  this.selectRef.current.clearValue()
                }
                this.toggleUpdateOrderStatusModal()
                await this.props.getOrders()
              } catch (error) {
                setSubmitting(false)
                const messages = error?.response?.data?.message;

                if (messages && typeof messages === 'object') {
                  Object.entries(messages).forEach(([field, errors]) => {
                    if (Array.isArray(errors)) {
                      errors.forEach((msg) => {
                        toast.error(`${field}: ${msg}`);
                      });
                    }
                  });
                } else {
                  // Fallback in case the format is different
                  toast.error('An unexpected error occurred.');
                }
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              setFieldTouched
            }) => (
              <div>
                <Modal.Body>
                  <Row>
                    <Form.Group
                      as={Col}
                      sm="12"
                      controlId="order_id_list"
                      style={{ marginTop: "1em" }}
                    >
                      <Form.Label column sm="12">
                        Order(s)
                      </Form.Label>

                      <Col sm="12">
                        <Select
                        ref={this.selectRef}
                          name="order_id_list"
                          className="is-invalid"
                          cacheOptions
                          loadOptions={this.loadOptions}
                          getOptionLabel={(option) => {
                            return (
                              <div>
                                <div>
                                  {`Order #${option.orderNumber}`}
                                  {option.moqNumber ? ` (for MOQ #${option.moqNumber})` : ""}
                                </div>

                                {option.orderStatus && (
                                  <div style={{ fontSize: "0.85em", color: "#666" }}>
                                    {`Status: ${option.orderStatus}`}

                                    {option.orderETA && (
                                      <>
                                        <br />
                                        {`ETA: ${new Date(option.orderETA).toLocaleDateString(undefined, {
                                          year: "numeric",
                                          month: "short",
                                          day: "numeric",
                                        })}`}
                                      </>
                                    )}
                                  </div>
                                )}
                              </div>
                            );
                          }}
                          getOptionValue={(option) => option.value}
                          defaultValue={values.order_id_list}
                          options={[]}
                          isMulti
                          placeholder="Search orders..."
                          isSearchable={true}
                          loadingMessage={() => "Searching..."}
                          noOptionsMessage={() => "No orders found"}
                          onChange={(value) => {
                            // If multiple selection is enabled, map to array of numbers
                            const values = value
                              ? value.map(option => Number(option.value))
                              : [];
                            setFieldValue("order_id_list", values);
                          }}
                          onBlur={() => setFieldTouched('order_id_list', true)}
                          touched={touched.order_id_list}
                        />
                        {errors.order_id_list && touched.order_id_list && (
                          <Form.Control.Feedback type="invalid">
                            {errors.order_id_list}
                          </Form.Control.Feedback>
                        )}
                      </Col>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group
                      as={Col}
                      sm="6"
                      controlId="status"
                      style={{ marginTop: "1em" }}
                    >
                      <Form.Label column sm="12">
                        Status
                      </Form.Label>

                      <Col sm="12">
                        <Form.Control
                          as="select"
                          isValid={touched.status && !errors.status}
                          value={values.status}
                          isInvalid={errors.status && touched.status}
                          name="status"
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <option value="">Choose...</option>

                          <option value="Submitted - Pending supplier acknowledgement">
                            Submitted - Pending supplier acknowledgement
                          </option>

                          <option value="Supplier acknowledged - Preparing goods">
                            Supplier acknowledged - Preparing goods
                          </option>

                          <option value="At shipper - Loading goods">
                            At shipper - Loading goods
                          </option>

                          <option value="Shipper loaded - Goods in transit">
                            Shipper loaded - Goods in transit
                          </option>

                          <option value="Arrived - Customs clearance">
                            Arrived - Customs clearance
                          </option>

                          <option value="Arrived - At shipper warehouse">
                            Arrived - At shipper warehouse
                          </option>

                          <option value="Order cancelled">
                            Order cancelled
                          </option>
                        </Form.Control>

                        {errors.status && touched.status && (
                          <Form.Control.Feedback type="invalid">
                            {errors.status}
                          </Form.Control.Feedback>
                        )}
                      </Col>
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      sm="6"
                      controlId="eta"
                      style={{ marginTop: "1em" }}
                    >
                      <Form.Label column sm="12">
                        ETA
                      </Form.Label>
                      <Col sm="12">
                        <Form.Control
                          type="datetime-local"
                          placeholder="ETA"
                          name="eta"
                          isValid={touched.eta && !errors.eta}
                          isInvalid={errors.eta && touched.eta}
                          value={values.eta}
                          onChange={(e) => setFieldValue("eta", e.target.value)}
                        />
                        
                        {(errors.eta || touched.eta) && (
                          <Form.Control.Feedback type="invalid">
                            {errors.eta}
                          </Form.Control.Feedback>
                        )}
                      </Col>
                    </Form.Group>
                  </Row>
                </Modal.Body>

                <Modal.Footer>
                  <Button variant="secondary" onClick={this.toggleUpdateOrderStatusModal}>
                    Close
                  </Button>

                  <Button
                    variant="primary"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Updating Orders…' : 'Update Status'}
                  </Button>
                </Modal.Footer>
              </div>
            )}
          </Formik>
        </Modal>
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    orders: state.orders,

    suppliers: state.suppliers,

    moqs: state.moqs,
  };
};

export default connect(mapStateToProps, {
  getOrders,
  editOrder,
  getMoqs,
  getSuppliers,
  getMoreOrders,
  searchOrder,
})(withRouter(Index));
